<template>
    <form class="row g-3" ref="form">
        <div class="col-12">
            <label for="carrier" class="form-label fw-bold">{{ $t("vehicleEntry.carrier") }}</label>
            <input type="text" class="form-control" id="carrier" v-model="localVehicle.carrier" required>
        </div>
        <div class="col-12">
            <label for="name" class="form-label fw-bold">{{ $t("vehicleEntry.driver_name") }}</label>
            <input type="text" class="form-control" id="name" v-model="localVehicle.driverName" required>
        </div>
        <div class="col-12">
            <label for="licencePlate" class="form-label fw-bold">{{ $t("vehicleEntry.licencePlate") }}</label>
            <Multiselect
                class="multiselect_custom"
                v-model="localVehicle.licencePlate"
                placeholder=""
                :options="licencePlateOptions"
                @search-change="getLicencePlates"
                :max="10"
                :searchable="true"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :show-no-results="false"
                :taggable="true"
                @tag="addNewLicencePlate"
                :track-by="null"
                :internal-search="true"
                :preselect-first="true"
                :select-label="$t('multiselect.pressToSelect')"
                :selected-label="$t('multiselect.selected')"
                :deselect-label="$t('multiselect.pressToDeselect')"
                :tagPlaceholder="$t('multiselect.tagPlaceholder')"
            >
                <template #noOptions>
                    <span>{{ $t("multiselect.noOptions") }}</span>
                </template>
            </Multiselect>
        </div>
        <div class="col-md-6">
            <label for="expectedFrom" class="form-label">{{ $t("vehicleEntry.expectedFrom") }}</label>
            <input type="datetime-local" class="form-control" id="expectedFrom" v-model="localVehicle.expectedFrom">
        </div>
        <div class="col-md-6">
            <label for="expectedTo" class="form-label">{{ $t("vehicleEntry.expectedTo") }}</label>
            <input
                type="datetime-local"
                class="form-control"
                id="expectedTo"
                v-model="localVehicle.expectedTo"
                :min="localVehicle.expectedFrom"
                :class="{ 'is-invalid': isInvalidDateRange }"
            >
        </div>
        <div class="col-md-12">
            <label class="form-label fw-bold">{{ $t("status.status") }}</label>
            <div class="d-flex flex-wrap gap-2">
                <div
                    v-for="status in statuses"
                    :key="status.id"
                    class="status-block p-2 me-3 mb-3 mb-md-0 rounded text-center"
                    :class="{ 'selected': localVehicle.status === status.id }"
                    @click="localVehicle.status = status.id"
                >
                    <icon :icon="status.icon" class="status_icon" />
                    <div class="fs-6 fw-bold">{{ $t("status.vehicleEntry." + status.name) }}</div>
                    <input
                        type="radio"
                        class="d-none"
                        :checked="localVehicle.status === status.id"
                    >
                </div>
            </div>
        </div>
        <div class="col-12">
            <label for="note" class="form-label">{{ $t("vehicleEntry.note") }}</label>
            <textarea class="form-control mb-3" id="note" v-model="localVehicle.note"></textarea>
        </div>
    </form>
</template>

<script>
    import Icon from '@/components/Icon.vue'
    import { formatDatetimeLocal } from '@/utils/date';
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Icon,
            Multiselect
        },
        props: {
            vehicle: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                localVehicle: {...this.vehicle},
                statuses: [],
                licencePlateOptions: [],
            }
        },
        created() {
            this.getStatuses();
        },
        methods: {
            validateData() {
                if (this.$refs.form.checkValidity() === false){
                    this.$refs.form.reportValidity();
                    return false;
                }
                return true;
            },
            submitForm() {
            if (!this.validateData()) return;
                return this.localVehicle;
            },
            getStatuses() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/statuses?model=vehicleentry`)
                .then(response => {
                    this.statuses = response.data;
                })
                .catch(error => {
                    console.error("Error loading statuses", error);
                });
            },

            getLicencePlates(query) {
                if (!query || query.length < 2) return;

                this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries/licence-plates?q=${query}`)
                    .then(response => {
                        this.licencePlateOptions = response.data;
                    })
                    .catch(err => {
                        console.error("Error fetching licence plates", err);
                    });
            },
            addNewLicencePlate(newPlate) {
                if (!this.licencePlateOptions.includes(newPlate)) {
                    this.licencePlateOptions.push(newPlate);
                }
                this.localVehicle.licencePlate = newPlate;
            },
        },
        computed: {
            isInvalidDateRange() {
                const from = new Date(this.localVehicle.expectedFrom);
                const to = new Date(this.localVehicle.expectedTo);
                return this.localVehicle.expectedFrom && this.localVehicle.expectedTo && to <= from;
            }
        },
        watch: {
            vehicle: {
                handler(newVal) {
                    this.localVehicle = {
                        carrier: newVal.carrier || "",
                        driverName: newVal.driver_name || "",
                        licencePlate: newVal.licence_plate || "",
                        expectedFrom: formatDatetimeLocal(newVal.expected_from),
                        expectedTo: formatDatetimeLocal(newVal.expected_to),
                        status: newVal.status || "",
                        note: newVal.note || ""
                    };
                },
                immediate: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/scss/abstracts/variables";
    @import "@/scss/base/typography.scss";

    .status_icon {
        width: 40px;
        height: 40px;
    }
</style>